import { Button, Card, Tabs } from 'antd';
import { EnumTypeReports } from '../../../Enums/TypeReports.enums';
import { useNavigate, useParams } from 'react-router-dom';
import ProfilePermissionService from "../../../services/profilePermissions.service";
import { capitalized } from '../../../services/utils';
import DisplayAlert from '../../../components/Commons/Alert';
import { ArrowLeftOutlined } from '@ant-design/icons';
import Statistics from '../List/Statistics';
import Reports from './Reports';

const ReportsTabs = {
    statistics: 'Estatisticas',
    ...EnumTypeReports,
};

export default function ReportsPage(props: any) {
    const { tab, subTab, id } = useParams();
    const navigate = useNavigate();

    const profilePermissionService = ProfilePermissionService.getInstance();

    const tabBarStyle = {
        backgroundColor: '#FFF',
        padding: '8px 52px 0px 24px',
        color: '#000',
        marginBottom: 0
    };

    const items = Object.keys(ReportsTabs).map(key => {
        let label = ReportsTabs[key as keyof typeof ReportsTabs];

        return {
            key,
            label,
            children: (
                <div className="content_page">
                    <Card styles={{ body: { padding: 8 } }}>
                        {
                            key === 'statistics'
                                ? <Statistics />
                                : <Reports tab={key as keyof typeof EnumTypeReports} subTab={subTab} tabBarStyle={tabBarStyle} id={id}>
                                    <DisplayAlert />
                                    {id && (
                                        <Button
                                            type="link"
                                            size="large"
                                            icon={<ArrowLeftOutlined />}
                                            onClick={() => navigate(`/control/reports/${tab}`)}
                                        >
                                            Voltar para lista
                                        </Button>
                                    )}
                                </Reports>
                        }
                    </Card>
                </div>
            )
        };
    });

    return (
        <Tabs
            tabBarStyle={tabBarStyle}
            size="large"
            defaultActiveKey={tab || 'statistics'}
            destroyOnHidden={true}
            items={items.filter((item: any) =>
                Object.keys(ReportsTabs).includes(item.key) ||
                (profilePermissionService.hasPermission([`control-reports${capitalized(item.key)}:read`]) ||
                    profilePermissionService.hasPermission([`control-reports${capitalized(item.key)}:write`]))
            )}
            onChange={(activeKey: string) => navigate(`/control/reports/${activeKey}`)}
        />
    );
}